import React from 'react';
import { styled } from '@linaria/react';
import { Icon } from '@daedalus/atlas/Icon';
import { Text } from '@daedalus/atlas/Text';
import { sanitizeHtml } from '@daedalus/core/src/_web/utils/dom';
import FormattedMessageWrapper from '@daedalus/core/src/localization/components/FormattedMessage';
export interface Props {
  /** Room Description */
  description: string;
}
const HtmlContentWrapper = /*#__PURE__*/styled('div')({
  name: "HtmlContentWrapper",
  class: "h18my5t8",
  propsAsIs: false
});
const Header = /*#__PURE__*/styled('div')({
  name: "Header",
  class: "h1j9ajzv",
  propsAsIs: false
});
const HtmlContent = ({
  text
}: {
  text: string;
}) => <HtmlContentWrapper dangerouslySetInnerHTML={{
  __html: sanitizeHtml(text)
}} />;
export const RoomDescription = ({
  description
}: Props) => {
  return <div>
      <Header>
        <Icon name="Room" size="md" colorPath="content.neutral.c600" />
        <Text variant="titleL">
          <FormattedMessageWrapper id="roomDescription" defaultMessage="Where you’ll stay" />
        </Text>
      </Header>
      <HtmlContent text={description} />
    </div>;
};

require("./RoomDescription.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./RoomDescription.tsx");